var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-layout"},[_vm._t("top"),_c('div',{staticClass:"left-side"},[_vm._t("left")],2),(_vm.rightPanelVisible)?_c('div',{staticClass:"right-side"},[_vm._t("right")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }